export enum ColumnTextAlign {
  inherit = 'inherit',
  left = 'left',
  center = 'center',
  right = 'right',
  justify = 'justify',
}
